export default "__VITE_ASSET__Os7s1YM9__"